import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage';
import LiveStreamPage from './pages/LiveStreamPage';
import TestPage from './pages/TestPage';
import TestAdmin from './pages/TestAdmin';
import DlcocPage from './pages/DlcocPage';
import DlcocAdmin from './pages/DlcocAdmin';
import BkrmmnPage from './pages/BkrmmnPage';
import BkrmmnAdmin from './pages/BkrmmnAdmin';
import PcocPage from './pages/PcocPage';
import PcocAdmin from './pages/PcocAdmin';
import MasterAdmin from './pages/MasterAdmin';
import YouTubeInstructions from './pages/YouTubeInstructions';
import DynamicPage from './pages/DynamicPage';
import DynamicAdmin from './pages/DynamicAdmin';
import PricingPage from './pages/PricingPage';
import SignUpPage from './pages/SignUpPage';
import SignagePage from './pages/SignagePage';
import WebsitesPage from './pages/WebsitesPage';
import ITServicesPage from './pages/ITServicesPage';
import ContactPage from './pages/ContactPage';
import SupportPage from './pages/SupportPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/services/signage" element={<SignagePage />} />
          <Route path="/services/websites" element={<WebsitesPage />} />
          <Route path="/services/it" element={<ITServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/live" element={<LiveStreamPage />} />
          {/* Legacy hardcoded routes */}
          <Route path="/test" element={<TestPage />} />
          <Route path="/test-admin" element={<TestAdmin />} />
          <Route path="/dlcoc" element={<DlcocPage />} />
          <Route path="/dlcoc-admin" element={<DlcocAdmin />} />
          <Route path="/bkrmmn" element={<BkrmmnPage />} />
          <Route path="/bkrmmn-admin" element={<BkrmmnAdmin />} />
          <Route path="/pcoc" element={<PcocPage />} />
          <Route path="/pcoc-admin" element={<PcocAdmin />} />
          <Route path="/master-admin" element={<MasterAdmin />} />
          <Route path="/youtube-setup" element={<YouTubeInstructions />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          {/* Dynamic routes for custom pages */}
          <Route path="/page/:pageId" element={<DynamicPage />} />
          <Route path="/page/:pageId/admin" element={<DynamicAdmin />} />
        </Routes>
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
